import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {KennethMustDie} from "../KennethMustDie";

export class KMDWinCapRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return KennethMustDie.model.gameData.brokeTheBank;
    }

    public start(controller: ISimplePresentationRunnerController): void {
        controller.setSkipCallback();

        KennethMustDie.keypadPlugin.setZeroBetSpinCounter(-1);
        KennethMustDie.winCap.playWinCap(() => controller.finish());
    }
}